enum ACTION_TYPES {
  ARTICLES_FETCH = 'ARTICLES_FETCH',
  ARTICLES_FETCH_RESPONSE = 'ARTICLES_FETCH_RESPONSE',
  ARTICLES_FETCH_ERROR = 'ARTICLES_FETCH_ERROR',
  ARTICLES_FETCH_ALL = 'ARTICLES_FETCH_ALL',
  ARTICLES_FETCH_ALL_RESPONSE = 'ARTICLES_FETCH_ALL_RESPONSE',
  ARTICLES_FETCH_ALL_ERROR = 'ARTICLES_FETCH_ALL_ERROR',
  AXIOS_ACTION = 'shared/middleware/axios',
  DIABLO_HERO_FETCH_ALL = 'DIABLO_HERO_FETCH_ALL',
  DIABLO_HERO_FETCH_ALL_RESPONSE = 'DIABLO_HERO_FETCH_ALL_RESPONSE',
  DIABLO_HERO_FETCH_ALL_ERROR = 'DIABLO_HERO_FETCH_ALL_ERROR',
}

export namespace Interfaces {
  export interface ActionType {
    type: ACTION_TYPES;
    data?: any;
  }
}

export default ACTION_TYPES;